import { Smartphone, Apple } from "lucide-react";
import { Button } from "@/components/ui/button";
import { APP_STORE_URL } from "@/lib/constants";

export function MySabbatAppCTA() {
  return (
    <div className="my-12 bg-gradient-to-br from-primary/5 via-accent/5 to-primary/10 border border-primary/20 rounded-2xl p-8">
      <div className="flex flex-col md:flex-row items-center gap-6">
        {/* Icon/illustration */}
        <div className="flex-shrink-0">
          <div className="w-20 h-20 bg-primary/10 rounded-2xl flex items-center justify-center">
            <Smartphone className="w-10 h-10 text-primary" />
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 text-center md:text-left">
          <h3 className="text-xl font-bold text-foreground mb-2">
            📱 Planlæg dit sabbatår med MySabbat
          </h3>
          <p className="text-muted-foreground mb-4">
            Hold styr på dit sabbatår med vores app –
            budgetplanlægger, tjeklister, rejsetips og meget mere samlet ét sted.
          </p>

          <Button asChild className="bg-primary hover:bg-primary/90 gap-2">
            <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
              <Apple className="w-4 h-4" />
              Download på App Store
            </a>
          </Button>
          <p className="text-xs text-muted-foreground mt-3">
            Gratis at downloade. Android kommer senere.
          </p>
        </div>
      </div>
    </div>
  );
}

export default MySabbatAppCTA;
